import React, {useEffect} from "react";
import {Image} from "../../../../components/Image";
import "./style.css";

const BENEFITS = [
    "Weight Loss",
    "Lower Risk of Type 2 Diabetes",
    "Improved Heart Health",
    "Cancer Prevention",
    "Longer Life Span"
];

export const WhatFasting = ({clicked, clickNext, isCurPage}) => {
    useEffect(() => {
        if (clicked && isCurPage) {
            clickNext("continue");
        }
    }, [clicked, clickNext, isCurPage]);

    return (
        <div className="gallery-page fasting-what-page">
            <div className="fasting-what-title-wrap">
                <h1 className="fasting-what-title">
                    What is <span>intermittent fasting</span>?
                </h1>
                <p className="fasting-what-subtitle">
                    During fasting you focus on when you eat, not what you eat.
                </p>
            </div>

            <div className="fasting-window-card">
                <div className="fasting-window-top">
                    <div className="fasting-window-label-group">
                        <div className="fasting-window-label">
                            <Image
                                src="/static/image/questionnaire/fasting/whatFasting/icon-eating-window.png"
                                alt=""
                                className="fasting-window-icon"
                                defaultLoad={true}
                            />
                            <span>Fasting Period</span>
                        </div>
                    </div>
                    <div className="fasting-window-label-group fasting-window-label-group-right">
                        <div className="fasting-window-label fasting-window-label-right">
                            <Image
                                src="/static/image/questionnaire/fasting/whatFasting/icon-fasting-period.png"
                                alt=""
                                className="fasting-window-icon"
                                defaultLoad={true}
                            />
                            <span>Eating Window</span>
                        </div>
                    </div>
                </div>
                <div className="fasting-window-bar">
                    <div className="fasting-window-dark">Avoid eating</div>
                    <div className="fasting-window-green">Enjoy your favorite foods!</div>
                </div>
            </div>

            <p className="fasting-what-copy">
                Fasting is a healthy way to lose weight that has been <strong>proven by science</strong>
            </p>

            <div className="fasting-benefits-card">
                <h2>Benefits of Intermittent Fasting:</h2>
                <ul>
                    {BENEFITS.map((benefit) => (
                        <li key={benefit}>
                            <span className="fasting-benefit-check">✓</span>
                            <span>{benefit}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};
